import { useState } from 'react'

import type { MembershipsCreatorV2ApiClient } from '@fourthwall/services/dist/MembershipsCreatorV2ApiClient'
import { useCreateImageResources } from '@modules/Dashboard/Memberships/hooks/useCreateImageResources'

import { useUpdateLiveStreamPostMutation } from './useUpdateLiveStreamPostMutation'

export const useUpdateLiveStreamPost = () => {
  const [isLoading, setLoading] = useState(false)
  const { updateLiveStreamPostMutation } = useUpdateLiveStreamPostMutation()
  const { createImageResources } = useCreateImageResources()

  const updateLiveStreamPost = async (
    id: string,
    thumbnail: File | string | undefined,
    payload: Parameters<typeof MembershipsCreatorV2ApiClient.updateLiveStreamPost>[1],
    handleSuccess: () => void,
  ) => {
    setLoading(true)

    const updatePayload = { ...payload }

    const onSuccess = () => {
      setLoading(false)
      handleSuccess()
    }

    if (typeof thumbnail === 'object') {
      await createImageResources({
        files: [thumbnail],
        onSuccess: (images) => {
          updatePayload.imageResource = {
            type: 'New',
            id: images[0].id,
          }
        },
      })
    } else if (typeof thumbnail === 'string') {
      updatePayload.imageResource = {
        type: 'Keep',
      }
    } else {
      updatePayload.imageResource = {
        type: 'Remove',
      }
    }

    updateLiveStreamPostMutation.mutateAsync([{ id: Number(id) }, { ...updatePayload }], {
      onSuccess,
      onError: () => setLoading(false),
    })
  }

  return {
    updateLiveStreamPost,
    isLoading,
  }
}
